import { DeviceResolver } from "./device_resolver";
import { FetchRequest } from "@rails/request.js";

const createCustomMapBubble = function ({OverlayView = google.maps.OverlayView, marker, location, map}) {
  const bubble_sample = document.querySelector('[data-selector="sample-bubble"]',);

  class CustomMapBubble extends OverlayView {
    PHOTOS_EXPIRATION = 900000; // ms
    AVAILABILITY_THRESHOLD = 4; // hours

    constructor(marker, location, map) {
      super();
      this.remove = this.remove.bind(this);
      this.marker = marker;
      this.latlng = new google.maps.LatLng(location.latitude, location.longitude);
      this.location = location;
      this.map = map;
      this.shouldBeRemoved = false;
      this.setMap(map);
    }

    createDiv() {
      const existingBubbles = document.querySelectorAll('[data-selector="sample-bubble"].show-bubble');
      if (existingBubbles.length > 0) {
        existingBubbles.forEach((item) => item.remove());
      }
      this.div = bubble_sample.cloneNode(true);
      this.div.style.display = "inline";
      this.div.classList.add("show-bubble");
      this.div.querySelector(".bubble-text").classList.add(this.obtainStyle() + "-border");
      this.div.querySelector(".bubble-text h2").innerHTML = this.location.human_name;
      this.div.querySelector(".bubble-text h2").classList.add(this.obtainStyle());
      if (this.div.querySelector(".bubble-text form")) {
        this.div.querySelector(".bubble-text form").setAttribute("action", `/maps/locations/${this.location.id}/modal_info`);
      }
      this.div.querySelector(".bubble-text h3").innerHTML = [this.location.street_address, this.location.city, this.location.state + " " + this.location.postal_code,].join(", ");
      this.div.querySelector(".bubble-text .space .sum").innerHTML = this.totalNumberSpaces();
      this.div.querySelector(".bubble-text .space .online-info .available",).innerHTML = this.availableSpaces();
      this.div.querySelector(".bubble-text .space .online-info .updated",).innerHTML = this.updatedAt();
      this.div.querySelector(".bubble-text .oversized-spaces").innerHTML = this.oversizedSpaces();
      this.div.querySelector(".bubble-text .free-hours").innerHTML = this.freeHours();
      this.div.querySelector(".bubble-text .rental-info .price").innerHTML = this.rentalPrice();
      this.div.querySelector(".bubble-text .rental-info .duration").innerHTML = this.rentalDuration();
      this.div.querySelector(".bubble-text .accepts").innerHTML = this.acceptedMethods();

      if (this.location.type === "problems") {
        this.div.querySelector(".problem-text .service-plans").innerHTML = this.servicePlans();
        this.div.querySelector(".problem-text .problem-reports").innerHTML = this.problemReports();
        this.div.querySelector(".problem-text .work-orders").innerHTML = this.workOrders();
        this.div.querySelector(".problem-text").classList.add("problem-text-padding");
      } else {
        this.div.querySelector(".problem-text").classList.remove("problem-text-padding");
      }
      this.loadPhotos();
    }

    workOrders() {
      if (this.location.work_orders.length === 0) {
        return "";
      }

      let ret = '<br /><strong>Work Orders</strong><br /><table class="problems-table"><tr><th class="blue-id">#ID</th><th>Due</th><th>Detail</th></tr>';
      this.location.work_orders.forEach((work_order) => {
        ret += '<tr><td><a href="' + work_order["url"] + '" title="' + work_order["id"] + '" target="_blank">' + work_order["id"] + "</a></td>";
        ret += "<td>" + work_order["due_date"] + "</td>";
        ret += "<td>" + this.truncateString(work_order["description"], 15) + "</td></tr>";
      });
      return ret + "</table>";
    }

    truncateString(str, num) {
      if (str === undefined) {
        return "";
      }
      if (str.length <= num) {
        return str;
      }

      return str.slice(0, num) + "...";
    }

    problemReports() {
      if (this.location.problem_reports.length === 0) {
        return "";
      }

      let ret = '<br /><strong>Problem Reports</strong><br /><table class="problems-table"><tr><th class="blue-id">#ID</th><th>Prty</th><th>Due</th><th>Title</th></tr>';
      this.location.problem_reports.forEach((problem_report) => {
        ret += '<tr><td  class="blue-id"><a href="' + problem_report["url"] + '" title="' + problem_report["id"] + '" target="_blank">' + problem_report["id"] + "</a></td>";
        ret += '<td><div class="priority ' + problem_report["priority_class"] + '"></div></td><td>' + problem_report["due_date"];
        ret += "</td><td>" + this.truncateString(problem_report["title"], 15) + "</td></tr>";
      });
      return ret + "</table>";
    }

    servicePlans() {
      if (this.location.service_plans.length === 0) {
        return '<div class="red">No plan</div>';
      }

      let ret = "<br />";
      this.location.service_plans.forEach((service_plan) => {
        ret += "<div><strong>" + I18n.t(`views.service_plans.${service_plan["name"]}`) + "</strong> ";
        if (service_plan["expired"] === true) {
          ret += '<span style="color: darkred">' + service_plan["expiration_date"] + "</span></div>";
        } else {
          ret += '<span class="small">Ends in ' + service_plan["expired_months"] + " months (" + service_plan["expiration_date"] + ")</span></div>";
        }
      });

      return ret;
    }

    obtainStyle() {
      const style = {
        eLocker: "locker", "Group Parking": "group", "Bike Hangar": "hangar", eRack: "erack", Vendor: "vendor",
      };
      return style[this.location.location_friendly_type];
    }

    totalNumberSpaces() {
      if (this.location.location_friendly_type === I18n.t("app.location.friendly_type.vendor")) {
        return "";
      }

      return I18n.t("modern.maps.list.additional_info.spaces.uniform", {
        number: this.location.num_spaces,
      });
    }

    availableSpaces() {
      if (!this.location.online || this.isOlderThan(this.AVAILABILITY_THRESHOLD)) {
        return "";
      }
      return I18n.t("modern.maps.list.additional_info.free_spaces", {
        number: this.location.num_available_spaces,
      });
    }

    oversizedSpaces() {
      const types = [];
      if (this.location.num_large_spaces > 0) types.push(I18n.t("modern.maps.list.additional_info.oversized_spaces.types.large"));
      if (this.location.num_xlarge_spaces > 0) types.push(I18n.t("modern.maps.list.additional_info.oversized_spaces.types.xlarge"));
      if (this.location.num_xxlarge_spaces > 0) types.push(I18n.t("modern.maps.list.additional_info.oversized_spaces.types.xxlarge"));

      if (types.length === 0) return "";

      return I18n.t("modern.maps.list.additional_info.oversized_spaces.has_types", { types: types.join(', ') });
    }

    updatedAt() {
      if (!this.location.online || this.isOlderThan(this.AVAILABILITY_THRESHOLD)) {
        return "";
      }
      return I18n.t("modern.maps.list.additional_info.last_update", {
        time_diff: distance_of_time_in_words_to_now(this.location.availability_updated_at,),
      });
    }

    freeHours() {
      if (this.location.pricing_scheme === "la_metro") {
        return "";
      }
      if (this.location.rental_free_hours.length === 0) {
        return "";
      }
      if (this.location.rental_free_hours.length === 1) {
        return I18n.t("modern.maps.list.additional_info.free_hours.simple", {
          number: this.location.rental_free_hours[0],
        });
      }
      return I18n.t("modern.maps.list.additional_info.free_hours.complex", {
        from: this.location.rental_free_hours.slice(0, -1).join(),
        to: this.location.rental_free_hours[this.location.rental_free_hours.length - 1],
      });
    }

    isOlderThan(threshold) {
      const timeDiff = new Date().getTime() - new Date(this.location.availability_updated_at * 1000).getTime();
      return timeDiff > threshold * 3600 * 1000;
    }

    rentalPrice() {
      switch (this.location.location_friendly_type) {
        case "eLocker":
        case "eRack":
          if (this.location.pricing_scheme === "la_metro") {
            return (this.location.pricing_tiers.tier1?.range_str || this.location.oversized_pricing_tiers.tier1?.range_str);
          }
          return this.location.rental_cost_base;
        case "Group Parking":
          if (this.location.is_access_hub) {
            return this.location.rental_cost_base;
          }
          return this.location.kiosk_cost_working;
        default:
          return "";
      }
    }

    rentalDuration() {
      if (this.location.location_friendly_type === I18n.t("app.location.friendly_type.vendor")) {
        return "";
      }
      return this.location.max_rental_duration;
    }

    acceptedMethods() {
      if (this.location.location_friendly_type === I18n.t("app.location.friendly_type.vendor")) {
        return "";
      }
      const accepted_methods = [];
      if (this.location.can_use_bikelink_card) {
        accepted_methods.push(I18n.t("modern.maps.list.additional_info.accepts.bikelink_card"),);
      }
      if (this.location.can_use_clipper_card) {
        accepted_methods.push(I18n.t("modern.maps.list.additional_info.accepts.clipper_card"),);
      }
      if (this.location.can_use_tap_card) {
        accepted_methods.push(I18n.t("modern.maps.list.additional_info.accepts.tap_card"),);
      }
      if (this.location.can_use_mobile_app) {
        accepted_methods.push(I18n.t("modern.maps.list.additional_info.accepts.mobile_app"),);
      }
      return (I18n.t("modern.maps.list.additional_info.accepts.title") + accepted_methods.join(" - "));
    }

    appendDivToOverlay() {
      this.getPanes().overlayImage.appendChild(this.div);
    }

    positionDiv() {
      const point = this.getProjection().fromLatLngToDivPixel(this.latlng);
      if (point && this.div) {
        if (DeviceResolver.isMobile() || DeviceResolver.mobileWidth()) {
          const indexMapMobile = document.querySelector(".index-map-mobile");
          if (indexMapMobile) {
            this.div.style.bottom = (indexMapMobile.clientHeight / 2) * -1 + "px";
          }
          const closeButton = document.querySelector(".map-bubble-close");
          if (closeButton && !closeButton.dataset.bubbleListenerAttached) {
            closeButton.dataset.bubbleListenerAttached = "true";
            closeButton.addEventListener("click", () => {
              document
                .querySelectorAll(".mobile-tooltip.show-bubble")
                .forEach((el) => {
                  el.style.display = "none";
                });
            });
          }
        } else {
          this.div.style.left = point.x + "px";
          this.div.style.top = point.y - (this.div.offsetHeight + this.marker.div.offsetHeight + 10) + "px";
        }
      }
    }

    draw() {
      if (!this.div && !this.shouldBeRemoved) {
        this.createDiv();
        this.appendDivToOverlay();
      }
      this.positionDiv();
    }

    getPosition() {
      return this.latlng;
    }

    remove() {
      this.shouldBeRemoved = true;
      if (!this.div) {
        return;
      }

      if (this.div.parentNode) {
        this.div.parentNode.removeChild(this.div);
      }
      this.div = null;
      this.setMap(null);
    }

    async loadPhotos() {
      if (new Date().getTime() - new Date(this.location.updated_at * 1000).getTime() < this.PHOTOS_EXPIRATION) {
        this.showPhotos(this.location.photos);
        return;
      }

      const request = new FetchRequest("get", `/maps/locations/${this.location.url_id}/images/`, {
        responseKind: "json",
      },);
      const response = await request.perform();
      if (response.ok) {
        const data = await response.json;
        this.showPhotos(data.images);
      }
    }

    showPhotos(images) {
      if (!this.div) {
        return;
      }

      this.carousel = this.div.querySelector(".carousel");
      const carouselIndicators = this.carousel.querySelector(".carousel-indicators",);
      const carouselInner = this.carousel.querySelector(".carousel-inner");

      const uid = "carousel" + Math.random() * 100;
      this.carousel.id = uid;

      images.forEach((image, index) => this.addToCarousel(carouselIndicators, carouselInner, image, index),);
      this.updateCarouselControls(this.carousel, uid, images.length);

      // Initialize Bootstrap carousel using vanilla JS
      if (window.bootstrap && this.carousel) {
        const carousel = new bootstrap.Carousel(this.carousel, {
          ride: "carousel",
        });
        carousel.cycle();
      }

      this.increaseDivWidth(images.length);
    }

    increaseDivWidth(imagesLength, maxAttempts = 100) {
      if (maxAttempts === 0 || this.div === null || imagesLength === 0) {
        return;
      }
      const callback = () => this.increaseDivWidth(imagesLength, maxAttempts - 1);
      if (this.div.offsetWidth === 0 || this.carousel.offsetWidth === 0) {
        setTimeout(callback, 25);
        return;
      }
      if (document.body.offsetWidth <= this.div.offsetWidth) {
        return;
      }

      this.div.style.width = this.div.offsetWidth + this.carousel.offsetWidth + "px";
      this.div.style.left = this.div.offsetLeft - this.carousel.offsetWidth + "px";
    }

    addToCarousel(carouselIndicators, carouselInner, image, index) {
      this.addCarouselIndicator(carouselIndicators, index);
      this.addCarouselPhoto(carouselInner, image, index);
    }

    addCarouselIndicator(carouselIndicators, index) {
      const indicatorElement = document.createElement("li");
      indicatorElement.dataset.target = "#" + this.carousel.id;
      indicatorElement.dataset.slideTo = index;
      if (index === 0) {
        indicatorElement.className = "active";
      }
      carouselIndicators.appendChild(indicatorElement);
    }

    addCarouselPhoto(carouselInner, image, index) {
      const styles = index === 0 ? "carousel-item active" : "carousel-item";
      const photoElement = document.createElement("div");
      photoElement.className = styles;
      const imageElement = document.createElement("img");
      imageElement.src = image.thumbnail_url;
      photoElement.appendChild(imageElement);
      carouselInner.appendChild(photoElement);
    }

    updateCarouselControls(carousel, uid, imageCount) {
      const prevControl = carousel.querySelector(".carousel-control-prev");
      const nextControl = carousel.querySelector(".carousel-control-next");
      const indicators = carousel.querySelector(".carousel-indicators");
      if (imageCount <= 1) {
        prevControl.style.display = "none";
        nextControl.style.display = "none";
        indicators.style.display = "none";
      } else {
        prevControl.href = "#" + uid;
        nextControl.href = "#" + uid;
      }
    }
  }

  return new CustomMapBubble(marker, location, map);
};

export { createCustomMapBubble };

// https://gist.github.com/sulf/1157895/1ba230bbc21bddccca5c8d22866f8886ac4f907b
const distance_of_time_in_words_to_now = function (from_time) {
  from_time = new Date(from_time * 1000).getTime();
  const to_time = Date.now();

  const distance_in_minutes = Math.round(Math.abs(to_time - from_time) / 60 / 1000,);
  const distance_in_seconds = Math.round(Math.abs(to_time - from_time) / 1000);

  if (0 <= distance_in_minutes && distance_in_minutes <= 1) {
    if (0 <= distance_in_seconds && distance_in_seconds <= 4) {
      return "less than 5 seconds";
    } else if (5 <= distance_in_seconds && distance_in_seconds <= 9) {
      return "less than 10 seconds";
    } else if (10 <= distance_in_seconds && distance_in_seconds <= 19) {
      return "less than 20 seconds";
    } else if (20 <= distance_in_seconds && distance_in_seconds <= 39) {
      return "less than half a minute";
    } else if (40 <= distance_in_seconds && distance_in_seconds <= 59) {
      return "less than 1 minute";
    } else {
      return "1 minute";
    }
  } else if (2 <= distance_in_minutes && distance_in_minutes <= 44) {
    return `${distance_in_minutes} minutes`;
  } else if (45 <= distance_in_minutes && distance_in_minutes <= 89) {
    return "about 1 hour";
  } else if (90 <= distance_in_minutes && distance_in_minutes <= 1439) {
    return `about ${Math.round(distance_in_minutes / 60.0)} hours`;
  } else if (1440 <= distance_in_minutes && distance_in_minutes <= 2529) {
    return "1 day";
  } else if (2530 <= distance_in_minutes && distance_in_minutes <= 43199) {
    return `${Math.round(distance_in_minutes / 1440.0)} days`;
  } else if (43200 <= distance_in_minutes && distance_in_minutes <= 86399) {
    return "about 1 month";
  } else if (86400 <= distance_in_minutes && distance_in_minutes <= 525599) {
    return `${Math.round(distance_in_minutes / 43200.0)} months`;
  } else {
    const distance_in_years = distance_in_minutes / 525600;
    const minute_offset_for_leap_year = (distance_in_years / 4) * 1440;
    const remainder = (distance_in_minutes - minute_offset_for_leap_year) % 525600;
    if (remainder < 131400) {
      return `about ${Math.round(distance_in_years)} years`;
    } else if (remainder < 394200) {
      return `over ${Math.round(distance_in_years)} years`;
    } else {
      return `almost ${Math.round(distance_in_years + 1)} years`;
    }
  }
};
